<div *ngIf="item" [formGroup]="form" class="margin5">
  <mat-chip-set>
    <mat-chip-option *ngFor="let item of elements" (removed)="remove(item)" style="margin: 5px">
      {{elementName(item)}}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip-option>
  </mat-chip-set>
  <mat-form-field [appearance]="appearance" class="width100Full">
    <mat-label>{{item.label}}</mat-label>
    <div class="input width100Full">
      <mat-chip-grid #chipList class="width100Full">
        <input [required]="form.controls[item.formControlName].errors?.['required']" #inputChips
          [formControl]="elementCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
          (matChipInputTokenEnd)="add($event)">
        <mat-icon matPrefix class="classInfo">search</mat-icon>
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        <mat-option *ngFor="let element of groups " [value]="element">
          <div class="row">
            <div>{{element[item.viewValueSelect!]}}</div>
          </div>
        </mat-option>
      </mat-autocomplete>
      <mat-icon *ngIf="item.info" class="classInfo" [matTooltip]="item.info">info</mat-icon>
    </div>
    <mat-error *ngIf="form.controls[item.formControlName].hasError('required')">{{utils.traslatei18n('requiredField')}}
    </mat-error>
  </mat-form-field>
</div>